import { IField } from "@lib";
import { Control, Label, TextBox, TextChangedEventArgs } from "@core/components/alt-ui/controls";
import ComboBoxItems from "./combobox-items";
import FieldSettingsItems from "./field-settings-items";

export default class FieldSettingsItemsComboBox extends FieldSettingsItems {
    private tbTitle!: TextBox;
    private pnlItems!: ComboBoxItems;
    private tbMacros!: TextBox;
    private lbError!: Label;

    protected initializeControls(): void {
        this.tbTitle = new TextBox();
        this.tbTitle.id = `${this.id}.title`;
        this.tbTitle.label = "Название";
        this.tbTitle.validation = "required";
        this.tbTitle.class = "mb-0.75";

        this.pnlItems = new ComboBoxItems();

        this.tbMacros = new TextBox();
        this.tbMacros.id = `${this.id}.macros`;
        this.tbMacros.label = "Макрос для документов";
        this.tbMacros.validation = "macro";
        this.tbMacros.addTextChangedHandler(this.changeMacro.bind(this));
        this.tbMacros.visible = !!this.context.canSpecifyMacro;

        this.lbError = new Label();
        this.lbError.class = "text-danger text-sm mb-0.75";
        this.lbError.visible = false;
    }

    public populateControls(field: IField): void {
        this.tbTitle.text = field.title ?? "";
        this.pnlItems.populateControls(field);

        if (field.custom) {
            this.tbMacros.text = field.macros && field.macros.length > 0 ? field.macros[0] : "";
        }
    }

    public get controls(): Control[] {
        return [this.tbTitle, this.pnlItems, this.tbMacros, this.lbError];
    }

    public getField(): IField {
        return {
            title: this.tbTitle.text,
            items: this.pnlItems.items,
            default: this.pnlItems.items.length > 0 ? this.pnlItems.items[0].id : undefined,
            macros: this.tbMacros.text.length > 0 ? [this.tbMacros.text.trim().toLowerCase()] : undefined,
        } as IField;
    }

    public changeMacro(sender: any, e: TextChangedEventArgs): void {
        this.validate();
    }

    public validate(): boolean {
        this.lbError.visible = false;

        const macro = this.tbMacros.text.trim().toLocaleLowerCase();

        if (!this.validateMacros(macro)) {
            this.lbError.text = "Макрос уже занят";
            this.lbError.visible = true;
            return false;
        }

        return true;
    }
}
